import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { environment } from 'environments/environment';

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  // Public
  public apiData = [];
  public onApiDataChange: BehaviorSubject<any>;

  
  // POUR LE CHARGEMENT (SPINNER)
  isLoading$: Observable<boolean>;
  isLoadingSubject: BehaviorSubject<boolean>;

  //URL DE BASE DU SERVICE A APPELER
  //*NB: environment.apiUrl --> CONTIENT L'ADRESSE IP DU SERVICE SPRING BOOT
  //*    '/notificationss' est le controller à appeler

  notificationsURL = environment.apiUrl+'notifications';

  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient, private _zone: NgZone) {
    this.onApiDataChange = new BehaviorSubject('');
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.isLoading$ = this.isLoadingSubject.asObservable();
    //this.getNotificationsData();
  }



  getAllnotifications(zones: number[], role: string) {
    this.isLoadingSubject.next(true);
    return this._http.post<any>(this.notificationsURL+"/"+role, zones).pipe(
        finalize(() => this.isLoadingSubject.next(false))
    );
  }

  //-> HISTORIQUE PAGINE (PAGE NOTIFICATIONS) : body { zones, debut, fin, type, page, limit }
  getHistoriqueNotifications(role: string, body: any) {
    this.isLoadingSubject.next(true);
    return this._http.post<any>(`${this.notificationsURL}/historique/${role}`, body).pipe(
        finalize(() => this.isLoadingSubject.next(false))
    );
  }

  //-> PREVIENT LA CLOCHE DE LA BARRE DE NAVIGATION QUE DES NOTIFICATIONS VIENNENT D'ETRE LUES
  notificationsLues$ = new Subject<void>();

  getAllnonLuNotifications(zones: number[], role: string) {
    this.isLoadingSubject.next(true);
    return this._http.post<any>(this.notificationsURL+"/notRead/"+role, zones).pipe(
        finalize(() => this.isLoadingSubject.next(false))
    );
  }

  //-> FLUX TEMPS REEL (SSE) DES NOUVELLES NOTIFICATIONS DE L'UTILISATEUR (ROLE + MAGASINS)
  //-> EventSource SE RECONNECTE TOUT SEUL ; onReconnexion PERMET DE RECHARGER CE QUI A ETE MANQUE PENDANT LA COUPURE
  fluxNotifications(zones: number[], role: string, onReconnexion?: () => void): Observable<any> {
    return new Observable(observer => {
      //-> EventSource NE PEUT PAS ENVOYER L'EN-TETE Authorization : LE JETON PASSE DANS L'URL
      const token = sessionStorage.getItem('token') || '';
      const url = `${this.notificationsURL}/stream?role=${encodeURIComponent(role)}&zones=${zones.join(",")}&token=${encodeURIComponent(token)}`;
      const source = new EventSource(url);
      let coupure = false;

      source.addEventListener("notification", (event: MessageEvent) => {
        this._zone.run(() => observer.next(JSON.parse(event.data)));
      });
      source.onerror = () => { coupure = true; };
      source.onopen = () => {
        if(coupure && onReconnexion) this._zone.run(() => onReconnexion());
        coupure = false;
      };

      return () => source.close();
    });
  }

  updateNotificationStatusLu(ids:number[]) {
    this.isLoadingSubject.next(true);
    return this._http.put<any>(`${this.notificationsURL}/read`, ids).pipe(
        finalize(() => this.isLoadingSubject.next(false))
    );
  }


  // deletenotification(id: number) {
  //   this.isLoadingSubject.next(true);
  //   return this._http.delete(`${this.notificationsURL}/${id}`).pipe(
  //       finalize(() => this.isLoadingSubject.next(false))
  //   );
  // }

  /********************************************************************************************
   * Get Notifications Data
   */
  // getNotificationsData(): Promise<any[]> {
  //   return new Promise((resolve, reject) => {
  //     this._http.get('api/notifications-data').subscribe((response: any) => {
  //       this.apiData = response;
  //       this.onApiDataChange.next(this.apiData);
  //       resolve(this.apiData);
  //     }, reject);
  //   });
  // }
}
